import { useBoolean } from "@imwebme/clay-hooks";
import type { SelectPortalProps } from "./Select.portal";
import { SelectPortal } from "./Select.portal";
import { SelectProvider } from "./Select.provider";
import type { SelectTriggerProps } from "./Select.trigger";
import { SelectTrigger } from "./Select.trigger";
import type { SelectProps } from "./Select.types";
import { SelectInput } from "./theme";
import type { SelectInputProps, SelectMultiInputProps } from "./theme/Select.Input";
import { SelectMultiInput } from "./theme/Select.Input";

export const Select = ({ children, closeOnSelect = true }: SelectProps) => {
  const { value, toggle, setOff } = useBoolean();

  return (
    <SelectProvider
      closeOnSelect={closeOnSelect}
      isOpen={value}
      toggleOpen={toggle}
      setOff={setOff}
    >
      {children}
    </SelectProvider>
  );
};

Select.Trigger = (props: SelectTriggerProps) => <SelectTrigger {...props} />;
Select.Input = (props: SelectInputProps) => <SelectInput {...props} />;
Select.Portal = (props: SelectPortalProps) => <SelectPortal {...props} />;
Select.MultiInput = (props: SelectMultiInputProps) => <SelectMultiInput {...props} />;
